import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import getText from '../shared/i18n/labels'
import { Modal } from 'react-bootstrap'
import { BwmCheckbox } from './form/BwmCheckboxB5'
import { useHistory } from 'react-router-dom'
import { BtnFill } from './BtnFill'

export const TipsModal = () => {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  const [show, setShow] = useState(false)
  const [dontShowTips, setDontShowTips] = useState(false)
  const history = useHistory()

  useEffect(() => {
    if (!history) return

    checkTipsModal()

    const unlisten = history.listen(() => {
      checkTipsModal()
    })

    return () => unlisten()
  }, [])

  const dontShowAgain = () => {
    setDontShowTips(!dontShowTips)
    localStorage.setItem('dontShowTips', !dontShowTips)
  }

  /**
   * Verifica se l'URL corrente è nella lista degli URL dove il modulo dei consigli deve essere mostrato.
   * Se la flag 'dontShowTips' è impostata in localStorage, il modulo viene nascosto.
   * Altrimenti, il modulo viene mostrato se l'URL corrente corrisponde ad uno degli URL predefiniti.
   */
  const checkTipsModal = () => {
    const urlsToShow = [
      '/app/cora/dashboard',
      '/app/crs/dashboard',
      '/app/arco/dashboard',
      '/app/blue/dashboard'
    ]

    if (['true', true].includes(localStorage.getItem('dontShowTips'))) {
      setShow(false)
      return
    }
    const checkUrl = urlsToShow.some((url) => location.pathname.startsWith(url))
    if (checkUrl) setShow(true)
    else setShow(false)
  }

  const onClose = () => {
    setShow(false)
  }

  return (
    <Modal
      show={show}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onClose}
      bsPrefix="modal-create modal"
      backdrop="static">
      <div className="bar"></div>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="d-flex">
          <i className="star-icon star-icon-check me-2" />
          <h2>{labels.NEW_UI_TIPS}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="text-medium mt-3">
          <li className="mb-3" dangerouslySetInnerHTML={{ __html: labels.VIEW_DETAILS_DBLCLICK }} />
          <li>{labels.ADD_NEW_ENTRY_INSTRUCTIONS}</li>
        </ul>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <BwmCheckbox
          label={labels.HIDE_THIS_MESSAGE_NEXT_TIME}
          name="hideThisMessageNextTime"
          className="form-control"
          checked={dontShowTips}
          onChange={() => dontShowAgain()}
        />
        <BtnFill text={labels.CLOSE} handlerOnClick={() => setShow(false)} />
      </Modal.Footer>
    </Modal>
  )
}
